import { useSelector } from 'react-redux'

import LandingWidget, {
  type LandingWidgetProps,
} from '~/components/common/LandingWidget'
import {
  LandingType,
  LandingWidgetName,
  WidgetWidthType,
} from '~/constants/landingConstants'
import { getWidgetDataIsLoading } from '~/store/duck/landing'

import CustomerSatisfactionWidget from './CustomerSatisfactionWidget'

type CustomerSatisfactionProps = {}

const CustomerSatisfaction = ({
  ...rest
}: LandingWidgetProps<CustomerSatisfactionProps>) => {
  const isLoading = useSelector(
    getWidgetDataIsLoading(
      LandingType.LANDING_DASHBOARD,
      LandingWidgetName.CUSTOMER_SATISFACTION,
    ),
  )

  return (
    <LandingWidget
      canNavigateToDetails={false}
      component={CustomerSatisfactionWidget}
      isLoading={isLoading}
      showSettings={false}
      widthType={WidgetWidthType.FULL_WIDTH}
      {...rest}
    />
  )
}

export default CustomerSatisfaction
